import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import ProductPropertyTab, { PropertyList } from '../../molecules/product-detail-accordion';

const ListWrapper = styled.div`
  display: flex;
`;

const List = styled(PropertyList)`
  list-style: none;
  margin-left: 0;
  flex: 1 1 0;
  max-width: 555px; /* 👀 */

  li {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    margin-left: 3rem;

    &::before {
      content: '';
      display: inline-block;
      height: 1.6rem;
      width: 1.6rem;
      background-image: url(${process.env.NEXT_PUBLIC_ASSET_HOST}/images/check-mark.svg);
      background-size: contain;
      background-repeat: no-repeat;
      position: absolute;
      left: -3rem;
      top: 0.4rem;
    }
  }
`;

const GoodToKnow = ({ product, goodToKnow }) => {
  if (!goodToKnow || goodToKnow.length === 0) return null;

  // breaks array into chunks of 4
  const [firstFour, lastFour = []] = goodToKnow.reduce((acc, cur, i) => {
    const idx = Math.floor(i / 4);
    acc[idx] = [].concat((acc[idx] || []), cur);
    return acc;
  }, []);

  return (goodToKnow && goodToKnow.length > 0) ? (
    <ProductPropertyTab title="Good to know" product={product}>
      <ListWrapper>
        <List element="ul" like="dec-4">
          {
            firstFour.map((item) =>
              // eslint-disable-next-line react/no-danger
              <li key={item.id} dangerouslySetInnerHTML={{ __html: item.value }} />)
          }
        </List>

        {
          lastFour && (
            <List element="ul" like="dec-4">
              {
                lastFour.map((item) =>
                  // eslint-disable-next-line react/no-danger
                  <li key={item.id} dangerouslySetInnerHTML={{ __html: item.value }} />)
              }
            </List>
          )
        }
      </ListWrapper>
    </ProductPropertyTab>
  ) : null;
};

GoodToKnow.defaultProps = {
  goodToKnow: []
};

GoodToKnow.propTypes = {
  product: PropTypes.object.isRequired,
  goodToKnow: PropTypes.array
};

export default GoodToKnow;
